import React from "react";
import BeatLoader from "react-spinners/BeatLoader";
import styles from "../styles/campaignNotifications.module.scss";

const HINTS = {
  eligible:
    "Select users to send, or select all eligible. Uncheck anyone to exclude them.",
  all: "Every app user, paginated. Select all to send to everyone. Uncheck anyone to exclude them.",
  sent: "Ledger of users this campaign has already attempted to notify.",
};

export default function CampaignUsersToolbar({
  audience,
  selectedCount,
  excludedCount = 0,
  isSelectAll,
  canSend,
  isSending,
  onSelectAll,
  onSend,
}) {
  const showActions = audience === "eligible" || audience === "all";
  const selectedLabel = isSelectAll
    ? excludedCount
      ? `All except ${excludedCount}`
      : audience === "eligible"
        ? "All eligible selected"
        : "All users selected"
    : `${selectedCount} selected`;

  return (
    <>
      {showActions ? (
        <div className={styles.toolbar}>
          <div className={styles.toolbarActions}>
            <span className={styles.selectedCount}>{selectedLabel}</span>
            <button
              type="button"
              className={`${styles.secondaryBtn} ${
                isSelectAll ? styles.secondaryBtnActive : ""
              }`}
              onClick={onSelectAll}
              aria-pressed={isSelectAll}
            >
              {isSelectAll ? "Clear all" : "Select all"}
            </button>
            <button
              type="button"
              className={styles.primaryBtn}
              onClick={onSend}
              disabled={!canSend}
            >
              {isSending ? <BeatLoader size={10} color="#fff" /> : "Send"}
            </button>
          </div>
        </div>
      ) : null}
      <p className={styles.toolbarHint}>{HINTS[audience] || HINTS.sent}</p>
    </>
  );
}
